import { EventEmitter, Type } from '@angular/core';
import { HisDynamicFieldConfig } from './formfield';
import { tap } from 'rxjs/operators';
import { HisDynamicFieldBase } from './field-base';
import { Subject, Observable } from 'rxjs';
import { FieldsAndSubscriptions } from './fields-and-subscriptions';

export class HisValueGroup {

    private fieldChangeSubject = new Subject<string>();
    /**
     * Observable that emits name (identifier) of a dynamic field
     * in case of a value change on that field.
     */
    nameOfChangedField = this.fieldChangeSubject.asObservable();

    private fieldsAndSubscriptions: FieldsAndSubscriptions = new FieldsAndSubscriptions();

    private currentNumberOfFields = 0;
    public valueGroupReady: EventEmitter<boolean> = new EventEmitter();

    constructor( private totalNumberOfFields: number ) { }

    public resetDynamicForm() {
        this.fieldsAndSubscriptions.resetDynamicForm();
    }

    public updateConfiguration( entireFormConfig: HisDynamicFieldConfig ) {
        this.fieldsAndSubscriptions.updateAllFieldConfigs( entireFormConfig );
    }

    /**
     * Allows a dynamic field component to register itself with a HisValueGroup.
     * Once all expected fields have registered, the container will emit
     * an event, signaling that it is ready to be used by other components
     *
     * @param dynamicField dynamic field component to be registered
     */
    public registerDynamicField( dynamicField: HisDynamicFieldBase<any>, valueChanges: Observable<any> ): void {
        let name = dynamicField.name;
        let subscription = valueChanges.pipe(
            tap( _ => this.fieldChangeSubject.next( name ) )
        ).subscribe();
        this.fieldsAndSubscriptions.add( dynamicField, subscription );
        this.currentNumberOfFields++;
        if ( this.currentNumberOfFields === this.totalNumberOfFields ) {
            this.valueGroupReady.emit( true );
        }
    }

    public getFirstByType( type: Type<HisDynamicFieldBase<any>> ): HisDynamicFieldBase<any> {
        return this.fieldsAndSubscriptions.findFirstByType( type );
    }

    public unregisterDynamicField( name: string ): void {
        this.fieldsAndSubscriptions.remove( name );
    }

    public getJson( ignoreEmptyValues: boolean = true ): any {
        let params = this.fieldsAndSubscriptions.getJson( ignoreEmptyValues );
        return params;
    }

    public dropDynamicFields() {
        this.fieldsAndSubscriptions.clear();
        this.currentNumberOfFields = 0;
    }
}
